import { render } from "./QuickTransfer.vue?vue&type=template&id=b7128bbe&ts=true"
import script from "./QuickTransfer.vue?vue&type=script&lang=ts"
export * from "./QuickTransfer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__